import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import "./svg-handler.m.css";

const getId = string => {
  try {
    return new URL(string).hash;
  } catch {
    return string ? "#" + get(string.split("#").reverse(), 0, "") : "#";
  }
};

export const SvgHandler = ({
  svgWrapperClazzName = "",
  clazzName = "",
  xlinkHref,
  height = "50px",
  width = "50px",
  viewBox
}) => {
  const { symbol, viewBox: autoViewBox } = xlinkHref || {};
  if (!viewBox) {
    viewBox = autoViewBox === "undefined" ? "0 0 24 24" : autoViewBox;
  }
  const svgId = symbol ? getId(symbol) : "";
  return (
    <div styleName={svgWrapperClazzName}>
      <svg height={height} width={width} className={`icon ${clazzName}`} viewBox={viewBox}>
        <use xlinkHref={svgId} />
      </svg>
    </div>
  );
};

SvgHandler.propTypes = {
  svgWrapperClazzName: PropTypes.string,
  clazzName: PropTypes.string,
  viewBox: PropTypes.string,
  xlinkHref: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string
};
